/*
 * @Author: Tahiti
 * @Date: 2025-01-27 12:00:00
 * @LastEditors: Tahiti
 * @LastEditTime: 2025-01-27 12:00:00
 * @Description: My Creations 页面多语言配置
 * @FilePath: /weryai-web/locales/modules/myCreations.ts
 */
export default {
    zh: {
        // 页面标题
        pageTitle: '我的创作',
        filterTitle: '筛选作品',

        // 筛选器
        all: '全部',
        videos: '视频',
        images: '图片',
        filterByTime: '按时间筛选',
        filterByType: '按类型筛选',

        // 状态提示
        loading: '加载中...',

        // 内容相关
        changeBackgroundToYellow: '把背景改为黄色',

        // 预览模态框
        download: '下载',
        downloading: '下载中...',

        // 空状态
        noContentTitle: '还没有创作任何内容',
        noContentDescription: '开始您的创作之旅，制作第一个AI生成的内容',
        createVideoNow: '立即创建视频',
        emptyTitle: '哎呀！看起来您还没有创建任何内容。',
        createNow: '立即创建',
        emptyStateIcon: '空状态图标',

        // 操作按钮
        preview: '预览',
        expand: '展开',
        edit: '编辑',
        downloadContent: '下载内容',

        // 内容类型
        imageCreation: '图片创作',
        videoCreation: '视频创作',

        // 分页器
        pagination: {
            total: '共 {total} 条',
            items: '条/页',
        },
        start_vip: '开通会员',
        vip_benefits: '解锁无限创作，4K超清画质',
        right_now: '立即升级',
        next_billing_date: '到期时间：{time}',
        my_creations: '我的作品',
        total_creations: '共 {total_number} 个',
        credits: '积分余额',
        recharge: '充值',
        lock_tips: '解锁无限创作额度与专属特权',
        
        // 新增内容
        type: '类型',
        query: '查询',
        startDate: '开始日期',
        endDate: '结束日期',
        
        // 内容类型标签
        image: '图片',
        video: '视频',
        music: '音乐',
        podcast: '播客',
        character: '角色',
        
        // 操作菜单
        deleteWork: '删除作品',
        copyLink: '复制链接',
        
        // 详情弹窗
        detailDescription: '这是一个由 WeryAI 生成的精彩作品。',
        podcastSpeakers: '说话人',
        podcastScript: '播客脚本',
        generationParams: '生成参数',
        prompt: '提示词',
        ratio: 'Ratio',
        model: 'Model',
        
        // 消息提示
        copySuccess: '复制成功',
        copyFailed: '复制失败',
        downloadFailed: '下载失败',
        
        // 无限滚动提示
        loadingMore: '加载中...',
        noMoreData: '已经到底了',
        loadMoreFailed: '加载失败，点击重试',
        
        // 详情标题
        aiCreation: 'AI创作',
        
        // 分享文案
        shareImageText: '用 AI 生成你想象中的任何画面 ｜Wery AI',
        shareVideoText: '让想法直接变成高质量视频 ｜Wery AI',
        shareMusicText: '用 AI 生成音乐与声音内容 ｜Wery AI',
    },
    en: {
        // Page title
        pageTitle: 'My Creations',
        filterTitle: 'Filter creations',

        // Filters
        all: 'All',
        videos: 'Videos',
        images: 'Images',
        filterByTime: 'Filter by time',
        filterByType: 'Filter by type',

        // Status messages
        loading: 'Loading...',

        // Content related
        changeBackgroundToYellow: 'Change background to yellow',

        // Preview modal
        download: 'Download',
        downloading: 'Downloading...',

        // Empty state
        noContentTitle: 'No content created yet',
        noContentDescription:
            'Start your creative journey by making your first AI-generated content',
        createVideoNow: 'Create Video Now',
        emptyTitle: "Oops! It looks like you haven't created anything yet.",
        createNow: 'Create Now',
        emptyStateIcon: 'Empty state icon',

        // Action buttons
        preview: 'Preview',
        expand: 'Expand',
        edit: 'Edit',
        downloadContent: 'Download Content',

        // Content types
        imageCreation: 'Image creation',
        videoCreation: 'Video creation',

        // Pagination
        pagination: {
            total: 'Total {total} items',
            items: 'items/page',
        },
        start_vip: 'Get VIP',
        vip_benefits: 'Unlock unlimited creations, 4K Ultra HD quality',
        right_now: 'Upgrade now',
        next_billing_date: 'Expiry date: {time}',
        my_creations: 'My Creations',
        total_creations: 'Total {total_number}',
        credits: 'Credit balance',
        recharge: 'Top up',
        lock_tips: 'Unlock unlimited creation quota and exclusive perks',
        
        // New content
        type: 'Type',
        query: 'Query',
        startDate: 'Start Date',
        endDate: 'End Date',
        
        // Content type labels
        image: 'Image',
        video: 'Video',
        music: 'Music',
        podcast: 'Podcast',
        character: 'Character',
        
        // Action menu
        deleteWork: 'Delete Work',
        copyLink: 'Copy Link',
        
        // Detail modal
        detailDescription: 'This is an amazing creation generated by WeryAI.',
        podcastSpeakers: 'Speakers',
        podcastScript: 'Script',
        generationParams: 'Generation Parameters',
        prompt: 'Prompt',
        ratio: 'Ratio',
        model: 'Model',
        
        // Message tips
        copySuccess: 'Copy successful',
        copyFailed: 'Copy failed',
        downloadFailed: 'Download failed',
        
        // Infinite scroll tips
        loadingMore: 'Loading...',
        noMoreData: 'No more data',
        loadMoreFailed: 'Load failed, click to retry',
        
        // Detail title
        aiCreation: 'AI Creation',
        
        // Share text
        shareImageText: 'Generate any scene you imagine with AI | Wery AI',
        shareVideoText: 'Turn ideas into high-quality videos | Wery AI',
        shareMusicText: 'Generate music and sound content with AI | Wery AI',
    },
    ja: {
        filterTitle: '作品を絞り込む',
        // フィルター
        all: 'すべて',
        videos: '動画',
        images: '画像',

        // ステータスメッセージ
        loading: '読み込み中...',

        // コンテンツ関連
        changeBackgroundToYellow: '背景を黄色に変更',

        // プレビューモーダル
        download: 'ダウンロード',
        downloading: 'ダウンロード中...',

        // 空の状態
        noContentTitle: 'まだコンテンツを作成していません',
        noContentDescription:
            '最初のAI生成コンテンツを作成して、クリエイティブな旅を始めましょう',
        createVideoNow: '今すぐ動画を作成',
        emptyTitle: 'おっと！まだ何も作成していないようです。',
        createNow: '今すぐ作成',

        // アクションボタン
        expand: '展開',
        edit: '編集',
        downloadContent: 'コンテンツをダウンロード',

        // ページネーション
        pageTitle: 'マイ創作',
        filterByTime: '時間でフィルタ',
        filterByType: 'タイプでフィルタ',
        emptyStateIcon: '空の状態アイコン',
        preview: 'プレビュー',
        imageCreation: '画像作成',
        videoCreation: '動画作成',
        pagination: {
            total: '合計 {total} 件',
            items: '件/ページ',
        },
        start_vip: 'VIPに登録',
        vip_benefits: '無制限の作成と4K超高画質を解放',
        right_now: '今すぐアップグレード',
        next_billing_date: '有効期限：{time}',
        my_creations: '私の作品',
        total_creations: '合計 {total_number} 件',
        credits: 'クレジット残高',
        recharge: 'チャージ',
        lock_tips: '無制限の創作枠と専用特典を解放',
        
        // 新しい内容
        type: 'タイプ',
        query: '検索',
        startDate: '開始日',
        endDate: '終了日',
        
        // コンテンツタイプラベル
        image: '画像',
        video: '動画',
        music: '音楽',
        podcast: 'ポッドキャスト',
        character: 'キャラクター',
        
        // アクションメニュー
        deleteWork: '作品を削除',
        copyLink: 'リンクをコピー',
        
        // 詳細モーダル
        detailDescription: 'これはWeryAIが生成した素晴らしい作品です。',
        podcastSpeakers: '話者',
        podcastScript: 'ポッドキャスト台本',
        generationParams: '生成パラメータ',
        prompt: 'プロンプト',
        ratio: '比率',
        model: 'モデル',
        
        // メッセージヒント
        copySuccess: 'コピーに成功しました',
        copyFailed: 'コピーに失敗しました',
        downloadFailed: 'ダウンロードに失敗しました',
        
        // 無限スクロールのヒント
        loadingMore: '読み込み中...',
        noMoreData: 'これ以上データはありません',
        loadMoreFailed: '読み込みに失敗しました。クリックして再試行',
        
        // 詳細タイトル
        aiCreation: 'AI創作',
        
        // 共有テキスト
        shareImageText: 'AIで想像したあらゆるシーンを生成 | Wery AI',
        shareVideoText: 'アイデアを高品質な動画に変換 | Wery AI',
        shareMusicText: 'AIで音楽とサウンドコンテンツを生成 | Wery AI',
    },
    ko: {
        filterTitle: '작품 필터',
        // 필터
        all: '전체',
        videos: '비디오',
        images: '이미지',

        // 상태 메시지
        loading: '로딩 중...',

        // 콘텐츠 관련
        changeBackgroundToYellow: '배경을 노란색으로 변경',

        // 미리보기 모달
        download: '다운로드',
        downloading: '다운로드 중...',

        // 빈 상태
        noContentTitle: '아직 콘텐츠를 생성하지 않았습니다',
        noContentDescription:
            '첫 번째 AI 생성 콘텐츠를 만들어 창작 여행을 시작하세요',
        createVideoNow: '지금 비디오 만들기',
        emptyTitle: '앗! 아직 아무것도 만들지 않았습니다.',
        createNow: '지금 만들기',

        // 액션 버튼
        expand: '확장',
        edit: '편집',
        downloadContent: '콘텐츠 다운로드',

        // 페이지네이션
        pageTitle: '나의 창작물',
        filterByTime: '시간별 필터',
        filterByType: '유형별 필터',
        emptyStateIcon: '빈 상태 아이콘',
        preview: '미리보기',
        imageCreation: '이미지 창작',
        videoCreation: '비디오 창작',
        pagination: {
            total: '총 {total} 개',
            items: '개/페이지',
        },
        start_vip: 'VIP 가입',
        vip_benefits: '무제한 생성, 4K 초고화질 잠금 해제',
        right_now: '지금 업그레이드',
        next_billing_date: '만료일: {time}',
        my_creations: '내 작품',
        total_creations: '총 {total_number}개',
        credits: '크레딧 잔액',
        recharge: '충전',
        lock_tips: '무제한 제작 한도와 전용 특전을 잠금 해제',
        
        // 새로운 내용
        type: '유형',
        query: '조회',
        startDate: '시작 날짜',
        endDate: '종료 날짜',
        
        // 콘텐츠 유형 레이블
        image: '이미지',
        video: '비디오',
        music: '음악',
        podcast: '팟캐스트',
        character: '캐릭터',
        
        // 액션 메뉴
        deleteWork: '작품 삭제',
        copyLink: '링크 복사',
        
        // 상세 모달
        detailDescription: 'WeryAI가 생성한 멋진 창작물입니다.',
        podcastSpeakers: '화자',
        podcastScript: '팟캐스트 스크립트',
        generationParams: '생성 매개변수',
        prompt: '프롬프트',
        ratio: '비율',
        model: '모델',
        
        // 메시지 힌트
        copySuccess: '복사 성공',
        copyFailed: '복사 실패',
        downloadFailed: '다운로드 실패',
        
        // 무한 스크롤 힌트
        loadingMore: '로딩 중...',
        noMoreData: '더 이상 데이터가 없습니다',
        loadMoreFailed: '로드 실패, 클릭하여 재시도',
        
        // 상세 제목
        aiCreation: 'AI 창작',
        
        // 공유 텍스트
        shareImageText: 'AI로 상상하는 모든 장면을 생성 | Wery AI',
        shareVideoText: '아이디어를 고품질 비디오로 변환 | Wery AI',
        shareMusicText: 'AI로 음악 및 사운드 콘텐츠 생성 | Wery AI',
    },
    es: {
        filterTitle: 'Filtrar creaciones',
        // Filtros
        all: 'Todo',
        videos: 'Videos',
        images: 'Imágenes',

        // Mensajes de estado
        loading: 'Cargando...',

        // Contenido relacionado
        changeBackgroundToYellow: 'Cambiar fondo a amarillo',

        // Modal de vista previa
        download: 'Descargar',
        downloading: 'Descargando...',

        // Estado vacío
        noContentTitle: 'Aún no has creado contenido',
        noContentDescription:
            'Comienza tu viaje creativo creando tu primer contenido generado por IA',
        createVideoNow: 'Crear Video Ahora',
        emptyTitle: '¡Ups! Parece que aún no has creado nada.',
        createNow: 'Crear Ahora',

        // Botones de acción
        expand: 'Expandir',
        edit: 'Editar',
        downloadContent: 'Descargar Contenido',

        // Paginación
        pageTitle: 'Mis Creaciones',
        filterByTime: 'Filtrar por tiempo',
        filterByType: 'Filtrar por tipo',
        emptyStateIcon: 'Icono de estado vacío',
        preview: 'Vista previa',
        imageCreation: 'Creación de imagen',
        videoCreation: 'Creación de video',
        pagination: {
            total: 'Total {total} elementos',
            items: 'elementos/página',
        },
        start_vip: 'Hazte VIP',
        vip_benefits: 'Desbloquea creaciones ilimitadas y calidad 4K Ultra HD',
        right_now: 'Mejorar ahora',
        next_billing_date: 'Fecha de vencimiento: {time}',
        my_creations: 'Mis creaciones',
        total_creations: 'Total {total_number}',
        credits: 'Saldo de créditos',
        recharge: 'Recargar',
        lock_tips:
            'Desbloquea un límite de creación ilimitado y beneficios exclusivos',
        
        // Contenido nuevo
        type: 'Tipo',
        query: 'Consultar',
        startDate: 'Fecha de inicio',
        endDate: 'Fecha de fin',
        
        // Etiquetas de tipo de contenido
        image: 'Imagen',
        video: 'Video',
        music: 'Música',
        podcast: 'Podcast',
        character: 'Personaje',
        
        // Menú de acciones
        deleteWork: 'Eliminar obra',
        copyLink: 'Copiar enlace',
        
        // Modal de detalles
        detailDescription: 'Esta es una increíble creación generada por WeryAI.',
        podcastSpeakers: 'Ponentes',
        podcastScript: 'Guion del podcast',
        generationParams: 'Parámetros de generación',
        prompt: 'Indicación',
        ratio: 'Relación',
        model: 'Modelo',
        
        // Consejos de mensajes
        copySuccess: 'Copia exitosa',
        copyFailed: 'Copia fallida',
        downloadFailed: 'Descarga fallida',
        
        // Consejos de desplazamiento infinito
        loadingMore: 'Cargando...',
        noMoreData: 'No hay más datos',
        loadMoreFailed: 'Carga fallida, haz clic para reintentar',
        
        // Título de detalles
        aiCreation: 'Creación de IA',
        
        // Texto para compartir
        shareImageText: 'Genera cualquier escena que imagines con IA | Wery AI',
        shareVideoText: 'Convierte ideas en videos de alta calidad | Wery AI',
        shareMusicText: 'Genera música y contenido de sonido con IA | Wery AI',
    },
    fr: {
        filterTitle: 'Filtrer les créations',
        // Filtres
        all: 'Tout',
        videos: 'Vidéos',
        images: 'Images',

        // Messages d'état
        loading: 'Chargement...',

        // Contenu lié
        changeBackgroundToYellow: 'Changer le fond en jaune',

        // Modal de prévisualisation
        download: 'Télécharger',
        downloading: 'Téléchargement...',

        // État vide
        noContentTitle: 'Aucun contenu créé pour le moment',
        noContentDescription:
            'Commencez votre voyage créatif en créant votre premier contenu généré par IA',
        createVideoNow: 'Créer une Vidéo Maintenant',
        emptyTitle: "Oups ! Il semble que vous n'ayez encore rien créé.",
        createNow: 'Créer Maintenant',

        // Boutons d'action
        expand: 'Développer',
        edit: 'Modifier',
        downloadContent: 'Télécharger le Contenu',

        // Pagination
        pageTitle: 'Mes Créations',
        filterByTime: 'Filtrar par temps',
        filterByType: 'Filtrar par type',
        emptyStateIcon: "Icône d'état vide",
        preview: 'Aperçu',
        imageCreation: "Création d'image",
        videoCreation: 'Création de vidéo',
        pagination: {
            total: 'Total {total} éléments',
            items: 'éléments/page',
        },
        start_vip: 'Devenir VIP',
        vip_benefits:
            'Débloquez des créations illimitées et la qualité 4K Ultra HD',
        right_now: 'Mettre à niveau maintenant',
        next_billing_date: "Date d'expiration : {time}",
        my_creations: 'Mes créations',
        total_creations: 'Total {total_number}',
        credits: 'Solde de crédits',
        recharge: 'Recharger',
        lock_tips:
            'Débloquez un quota de création illimité et des avantages exclusifs',
        
        // Nouveau contenu
        type: 'Type',
        query: 'Requête',
        startDate: 'Date de début',
        endDate: 'Date de fin',
        
        // Étiquettes de type de contenu
        image: 'Image',
        video: 'Vidéo',
        music: 'Musique',
        podcast: 'Podcast',
        character: 'Personnage',
        
        // Menu d\'action
        deleteWork: 'Supprimer l\'œuvre',
        copyLink: 'Copier le lien',
        
        // Modal de détails
        detailDescription: 'C\'est une création incroyable générée par WeryAI.',
        podcastSpeakers: 'Intervenants',
        podcastScript: 'Script du podcast',
        generationParams: 'Paramètres de génération',
        prompt: 'Invite',
        ratio: 'Ratio',
        model: 'Modèle',
        
        // Conseils de message
        copySuccess: 'Copie réussie',
        copyFailed: 'Échec de la copie',
        downloadFailed: 'Échec du téléchargement',
        
        // Conseils de défilement infini
        loadingMore: 'Chargement...',
        noMoreData: 'Plus de données',
        loadMoreFailed: 'Échec du chargement, cliquez pour réessayer',
        
        // Titre du détail
        aiCreation: 'Création IA',
        
        // Texte de partage
        shareImageText: 'Générez n\'importe quelle scène que vous imaginez avec l\'IA | Wery AI',
        shareVideoText: 'Transformez vos idées en vidéos de haute qualité | Wery AI',
        shareMusicText: 'Générez de la musique et du contenu sonore avec l\'IA | Wery AI',
    },
    de: {
        filterTitle: 'Kreationen filtern',
        // Filter
        all: 'Alle',
        videos: 'Videos',
        images: 'Bilder',

        // Statusmeldungen
        loading: 'Wird geladen...',

        // Inhalt bezogen
        changeBackgroundToYellow: 'Hintergrund zu gelb ändern',

        // Vorschau-Modal
        download: 'Herunterladen',
        downloading: 'Herunterladen...',

        // Leerer Zustand
        noContentTitle: 'Noch kein Inhalt erstellt',
        noContentDescription:
            'Beginnen Sie Ihre kreative Reise, indem Sie Ihren ersten KI-generierten Inhalt erstellen',
        createVideoNow: 'Jetzt Video Erstellen',
        emptyTitle:
            'Hoppla! Es sieht so aus, als hätten Sie noch nichts erstellt.',
        createNow: 'Jetzt Erstellen',

        // Aktionsschaltflächen
        expand: 'Erweitern',
        edit: 'Bearbeiten',
        downloadContent: 'Inhalt Herunterladen',

        // Paginierung
        pageTitle: 'Meine Kreationen',
        filterByTime: 'Nach Zeit filtern',
        filterByType: 'Nach Typ filtern',
        emptyStateIcon: 'Leerer Status-Icon',
        preview: 'Vorschau',
        imageCreation: 'Bild-Erstellung',
        videoCreation: 'Video-Erstellung',
        pagination: {
            total: 'Gesamt {total} Elemente',
            items: 'Elemente/Seite',
        },
        start_vip: 'VIP freischalten',
        vip_benefits:
            'Unbegrenzte Kreationen & 4K-Ultra-HD-Qualität freischalten',
        right_now: 'Jetzt upgraden',
        next_billing_date: 'Ablaufdatum: {time}',
        my_creations: 'Meine Kreationen',
        total_creations: 'Insgesamt {total_number}',
        credits: 'Credit-Guthaben',
        recharge: 'Aufladen',
        lock_tips:
            'Unbegrenztes Erstellungskontingent und exklusive Vorteile freischalten',
        
        // Neuer Inhalt
        type: 'Typ',
        query: 'Abfragen',
        startDate: 'Startdatum',
        endDate: 'Enddatum',
        
        // Inhaltstyp-Etiketten
        image: 'Bild',
        video: 'Video',
        music: 'Musik',
        podcast: 'Podcast',
        character: 'Charakter',
        
        // Aktionsmenü
        deleteWork: 'Werk löschen',
        copyLink: 'Link kopieren',
        
        // Detailmodal
        detailDescription: 'Dies ist eine erstaunliche Kreation, die von WeryAI generiert wurde.',
        podcastSpeakers: 'Sprecher',
        podcastScript: 'Podcast-Skript',
        generationParams: 'Generierungsparameter',
        prompt: 'Eingabeaufforderung',
        ratio: 'Verhältnis',
        model: 'Modell',
        
        // Nachrichtenhinweise
        copySuccess: 'Erfolgreich kopiert',
        copyFailed: 'Kopieren fehlgeschlagen',
        downloadFailed: 'Download fehlgeschlagen',
        
        // Unendliche Scroll-Hinweise
        loadingMore: 'Lädt...',
        noMoreData: 'Keine weiteren Daten',
        loadMoreFailed: 'Laden fehlgeschlagen, klicken Sie zum Wiederholen',
        
        // Detailtitel
        aiCreation: 'KI-Kreation',
        
        // Teilen-Text
        shareImageText: 'Generieren Sie jede Szene, die Sie sich vorstellen, mit KI | Wery AI',
        shareVideoText: 'Verwandeln Sie Ideen in hochwertige Videos | Wery AI',
        shareMusicText: 'Generieren Sie Musik und Sound-Inhalte mit KI | Wery AI',
    },
    ru: {
        filterTitle: 'Фильтр работ',
        // Фильтры
        all: 'Все',
        videos: 'Видео',
        images: 'Изображения',

        // Сообщения о состоянии
        loading: 'Загрузка...',

        // Связанный контент
        changeBackgroundToYellow: 'Изменить фон на желтый',

        // Модальное окно предварительного просмотра
        download: 'Скачать',
        downloading: 'Загрузка...',

        // Пустое состояние
        noContentTitle: 'Контент еще не создан',
        noContentDescription:
            'Начните свое творческое путешествие, создав первый контент, сгенерированный ИИ',
        createVideoNow: 'Создать Видео Сейчас',
        emptyTitle: 'Ой! Похоже, вы еще ничего не создали.',
        createNow: 'Создать Сейчас',

        // Кнопки действий
        expand: 'Развернуть',
        edit: 'Редактировать',
        downloadContent: 'Скачать Контент',

        // Пагинация
        pageTitle: 'Мои творения',
        filterByTime: 'Фильтр по времени',
        filterByType: 'Фильтр по типу',
        emptyStateIcon: 'Значок пустого состояния',
        preview: 'Предпросмотр',
        imageCreation: 'Создание изображений',
        videoCreation: 'Создание видео',
        pagination: {
            total: 'Всего {total} элементов',
            items: 'элементов/стр',
        },
        start_vip: 'Оформить VIP',
        vip_benefits:
            'Разблокируйте безлимитное создание и качество 4K Ultra HD',
        right_now: 'Обновить сейчас',
        next_billing_date: 'Дата окончания: {time}',
        my_creations: 'Мои работы',
        total_creations: 'Всего {total_number}',
        credits: 'Баланс кредитов',
        recharge: 'Пополнить',
        lock_tips:
            'Разблокируйте неограниченный лимит на создание и эксклюзивные привилегии',
        
        // Новый контент
        type: 'Тип',
        query: 'Запрос',
        startDate: 'Начальная дата',
        endDate: 'Конечная дата',
        
        // Метки типа контента
        image: 'Изображение',
        video: 'Видео',
        music: 'Музыка',
        podcast: 'Подкаст',
        character: 'Персонаж',
        
        // Меню действий
        deleteWork: 'Удалить работу',
        copyLink: 'Копировать ссылку',
        
        // Детальный модальный
        detailDescription: 'Это потрясающее творение, созданное WeryAI.',
        podcastSpeakers: 'Спикеры',
        podcastScript: 'Сценарий подкаста',
        generationParams: 'Параметры генерации',
        prompt: 'Запрос',
        ratio: 'Соотношение',
        model: 'Модель',
        
        // Подсказки сообщений
        copySuccess: 'Успешно скопировано',
        copyFailed: 'Не удалось скопировать',
        downloadFailed: 'Не удалось загрузить',
        
        // Подсказки бесконечной прокрутки
        loadingMore: 'Загрузка...',
        noMoreData: 'Больше нет данных',
        loadMoreFailed: 'Не удалось загрузить, нажмите для повтора',
        
        // Заголовок детали
        aiCreation: 'ИИ творчество',
        
        // Текст для публикации
        shareImageText: 'Создавайте любые сцены, которые вы представляете, с помощью ИИ | Wery AI',
        shareVideoText: 'Превращайте идеи в высококачественные видео | Wery AI',
        shareMusicText: 'Создавайте музыку и звуковой контент с помощью ИИ | Wery AI',
    },
    pt: {
        filterTitle: 'Filtrar criações',
        // Filtros
        all: 'Tudo',
        videos: 'Vídeos',
        images: 'Imagens',

        // Mensagens de status
        loading: 'Carregando...',

        // Conteúdo relacionado
        changeBackgroundToYellow: 'Mudar fundo para amarelo',

        // Modal de visualização
        download: 'Baixar',
        downloading: 'Baixando...',

        // Estado vazio
        noContentTitle: 'Nenhum conteúdo criado ainda',
        noContentDescription:
            'Comece sua jornada criativa criando seu primeiro conteúdo gerado por IA',
        createVideoNow: 'Criar Vídeo Agora',
        emptyTitle: 'Ops! Parece que você ainda não criou nada.',
        createNow: 'Criar Agora',

        // Botões de ação
        expand: 'Expandir',
        edit: 'Editar',
        downloadContent: 'Baixar Conteúdo',

        // Paginação
        pageTitle: 'Minhas Criações',
        filterByTime: 'Filtrar por tempo',
        filterByType: 'Filtrar por tipo',
        emptyStateIcon: 'Ícone de estado vazio',
        preview: 'Visualizar',
        imageCreation: 'Criação de imagem',
        videoCreation: 'Criação de vídeo',
        pagination: {
            total: 'Total {total} itens',
            items: 'itens/página',
        },
        start_vip: 'Assinar VIP',
        vip_benefits: 'Desbloqueie criações ilimitadas e qualidade 4K Ultra HD',
        right_now: 'Atualizar agora',
        next_billing_date: 'Data de expiração: {time}',
        my_creations: 'Minhas criações',
        total_creations: 'Total {total_number}',
        credits: 'Saldo de créditos',
        recharge: 'Recarregar',
        lock_tips: 'Desbloqueie criação ilimitada e benefícios exclusivos',
        
        // Novo conteúdo
        type: 'Tipo',
        query: 'Consultar',
        startDate: 'Data de início',
        endDate: 'Data de fim',
        
        // Etiquetas de tipo de conteúdo
        image: 'Imagem',
        video: 'Vídeo',
        music: 'Música',
        podcast: 'Podcast',
        character: 'Personagem',
        
        // Menu de ações
        deleteWork: 'Excluir obra',
        copyLink: 'Copiar link',
        
        // Modal de detalhes
        detailDescription: 'Esta é uma criação incrível gerada por WeryAI.',
        podcastSpeakers: 'Locutores',
        podcastScript: 'Roteiro do podcast',
        generationParams: 'Parâmetros de geração',
        prompt: 'Prompt',
        ratio: 'Proporção',
        model: 'Modelo',
        
        // Dicas de mensagem
        copySuccess: 'Cópia bem-sucedida',
        copyFailed: 'Falha ao copiar',
        downloadFailed: 'Falha no download',
        
        // Dicas de rolagem infinita
        loadingMore: 'Carregando...',
        noMoreData: 'Não há mais dados',
        loadMoreFailed: 'Falha ao carregar, clique para tentar novamente',
        
        // Título do detalhe
        aiCreation: 'Criação de IA',
        
        // Texto de compartilhamento
        shareImageText: 'Gere qualquer cena que você imaginar com IA | Wery AI',
        shareVideoText: 'Transforme ideias em vídeos de alta qualidade | Wery AI',
        shareMusicText: 'Gere música e conteúdo sonoro com IA | Wery AI',
    },
    it: {
        filterTitle: 'Filtra creazioni',
        // Filtri
        all: 'Tutto',
        videos: 'Video',
        images: 'Immagini',

        // Messaggi di stato
        loading: 'Caricamento...',

        // Contenuto correlato
        changeBackgroundToYellow: 'Cambia sfondo in giallo',

        // Modal di anteprima
        download: 'Scarica',
        downloading: 'Scaricamento...',

        // Stato vuoto
        noContentTitle: 'Nessun contenuto creato ancora',
        noContentDescription:
            'Inizia il tuo viaggio creativo creando il tuo primo contenuto generato da IA',
        createVideoNow: 'Crea Video Ora',
        emptyTitle: 'Ops! Sembra che tu non abbia ancora creato nulla.',
        createNow: 'Crea Ora',

        // Pulsanti di azione
        expand: 'Espandi',
        edit: 'Modifica',
        downloadContent: 'Scarica Contenuto',

        // Paginazione
        pageTitle: 'Le Mie Creazioni',
        filterByTime: 'Filtra per tempo',
        filterByType: 'Filtra per tipo',
        emptyStateIcon: 'Icona stato vuoto',
        preview: 'Anteprima',
        imageCreation: 'Creazione immagine',
        videoCreation: 'Creazione video',
        pagination: {
            total: 'Totale {total} elementi',
            items: 'elementi/pagina',
        },
        start_vip: 'Attiva VIP',
        vip_benefits: 'Sblocca creazioni illimitate e qualità 4K Ultra HD',
        right_now: 'Aggiorna ora',
        next_billing_date: 'Data di scadenza: {time}',
        my_creations: 'Le mie creazioni',
        total_creations: 'Totale {total_number}',
        credits: 'Saldo crediti',
        recharge: 'Ricarica',
        lock_tips: 'Sblocca creazioni illimitate e vantaggi esclusivi',
        
        // Nuovo contenuto
        type: 'Tipo',
        query: 'Query',
        startDate: 'Data di inizio',
        endDate: 'Data di fine',
        
        // Etichette tipo di contenuto
        image: 'Immagine',
        video: 'Video',
        music: 'Musica',
        podcast: 'Podcast',
        character: 'Personaggio',
        
        // Menu azioni
        deleteWork: 'Elimina opera',
        copyLink: 'Copia link',
        
        // Modale dettagli
        detailDescription: 'Questa è una creazione straordinaria generata da WeryAI.',
        podcastSpeakers: 'Speaker',
        podcastScript: 'Script del podcast',
        generationParams: 'Parametri di generazione',
        prompt: 'Prompt',
        ratio: 'Rapporto',
        model: 'Modello',
        
        // Suggerimenti messaggi
        copySuccess: 'Copia riuscita',
        copyFailed: 'Copia fallita',
        downloadFailed: 'Download fallito',
        
        // Suggerimenti scorrimento infinito
        loadingMore: 'Caricamento...',
        noMoreData: 'Nessun altro dato',
        loadMoreFailed: 'Caricamento fallito, clicca per riprovare',
        
        // Titolo dettaglio
        aiCreation: 'Creazione IA',
        
        // Testo di condivisione
        shareImageText: 'Genera qualsiasi scena immagini con l\'IA | Wery AI',
        shareVideoText: 'Trasforma idee in video di alta qualità | Wery AI',
        shareMusicText: 'Genera musica e contenuti audio con l\'IA | Wery AI',
    },
    ar: {
        filterTitle: 'تصفية الأعمال',
        // المرشحات
        all: 'الكل',
        videos: 'فيديوهات',
        images: 'صور',

        // رسائل الحالة
        loading: 'جاري التحميل...',

        // المحتوى المرتبط
        changeBackgroundToYellow: 'تغيير الخلفية إلى الأصفر',

        // نافذة المعاينة
        download: 'تحميل',
        downloading: 'جاري التحميل...',

        // الحالة الفارغة
        noContentTitle: 'لم يتم إنشاء أي محتوى بعد',
        noContentDescription:
            'ابدأ رحلتك الإبداعية بإنشاء أول محتوى منشأ بالذكاء الاصطناعي',
        createVideoNow: 'إنشاء فيديو الآن',
        emptyTitle: 'عذراً! يبدو أنك لم تنشئ أي شيء بعد.',
        createNow: 'إنشاء الآن',

        // أزرار الإجراءات
        expand: 'توسيع',
        edit: 'تحرير',
        downloadContent: 'تحميل المحتوى',

        // الترقيم
        pageTitle: 'إبداعاتي',
        filterByTime: 'تصفية حسب الوقت',
        filterByType: 'تصفية حسب النوع',
        emptyStateIcon: 'أيقونة الحالة الفارغة',
        preview: 'معاينة',
        imageCreation: 'إنشاء صورة',
        videoCreation: 'إنشاء فيديو',
        pagination: {
            total: 'الإجمالي {total} عنصر',
            items: 'عناصر/صفحة',
        },
        start_vip: 'الترقية إلى VIP',
        vip_benefits: 'افتح إبداعات غير محدودة وجودة 4K فائقة الدقة',
        right_now: 'الترقية الآن',
        next_billing_date: 'تاريخ الانتهاء: {time}',
        my_creations: 'أعمالي',
        total_creations: 'الإجمالي {total_number}',
        credits: 'رصيد النقاط',
        recharge: 'إعادة الشحن',
        lock_tips: 'افتح إنشاءات غير محدودة وامتيازات حصرية',
        
        // محتوى جديد
        type: 'النوع',
        query: 'استعلام',
        startDate: 'تاريخ البداية',
        endDate: 'تاريخ النهاية',
        
        // تسميات نوع المحتوى
        image: 'صورة',
        video: 'فيديو',
        music: 'موسيقى',
        podcast: 'بودكاست',
        character: 'شخصية',
        
        // قائمة الإجراءات
        deleteWork: 'حذف العمل',
        copyLink: 'نسخ الرابط',
        
        // نافذة التفاصيل
        detailDescription: 'هذا إبداع مذهل تم إنشاؤه بواسطة WeryAI.',
        podcastSpeakers: 'المتحدثون',
        podcastScript: 'نص البودكاست',
        generationParams: 'معاملات الإنشاء',
        prompt: 'المطالبة',
        ratio: 'النسبة',
        model: 'النموذج',
        
        // نصائح الرسائل
        copySuccess: 'نجح النسخ',
        copyFailed: 'فشل النسخ',
        downloadFailed: 'فشل التحميل',
        
        // نصائح التمرير اللانهائي
        loadingMore: 'جاري التحميل...',
        noMoreData: 'لا توجد المزيد من البيانات',
        loadMoreFailed: 'فشل التحميل، انقر لإعادة المحاولة',
        
        // عنوان التفاصيل
        aiCreation: 'إبداع الذكاء الاصطناعي',
        
        // نص المشاركة
        shareImageText: 'أنشئ أي مشهد تتخيله باستخدام الذكاء الاصطناعي | Wery AI',
        shareVideoText: 'حول الأفكار إلى مقاطع فيديو عالية الجودة | Wery AI',
        shareMusicText: 'أنشئ الموسيقى والمحتوى الصوتي باستخدام الذكاء الاصطناعي | Wery AI',
    },
    tw: {
        // Page title
        pageTitle: '我的創作',
        filterTitle: '篩選作品',

        // Filters
        all: '全部',
        videos: '影片',
        images: '圖片',
        filterByTime: '依時間篩選',
        filterByType: '依類型篩選',

        // Status messages
        loading: '載入中...',

        // Content related
        changeBackgroundToYellow: '將背景改為黃色',

        // Preview modal
        download: '下載',
        downloading: '下載中...',

        // Empty state
        noContentTitle: '尚未建立任何內容',
        noContentDescription: '從建立第一個 AI 生成內容開始你的創作旅程',
        createVideoNow: '立即建立影片',
        emptyTitle: '哎呀！看起來你還沒有建立任何內容。',
        createNow: '立即建立',
        emptyStateIcon: '空狀態圖示',

        // Action buttons
        preview: '預覽',
        expand: '展開',
        edit: '編輯',
        downloadContent: '下載內容',

        // Content types
        imageCreation: '圖片創作',
        videoCreation: '影片創作',

        // Pagination
        pagination: {
            total: '共 {total} 項',
            items: '項/頁',
        },
        start_vip: '開通會員',
        vip_benefits: '解鎖無限創作，4K超清畫質',
        right_now: '立即升級',
        next_billing_date: '到期時間：{time}',
        my_creations: '我的作品',
        total_creations: '共 {total_number} 個',
        credits: '積分餘額',
        recharge: '充值',
        lock_tips: '解鎖無限創作額度與專屬特權',
        
        // 新增內容
        type: '類型',
        query: '查詢',
        startDate: '開始日期',
        endDate: '結束日期',
        
        // 內容類型標籤
        image: '圖片',
        video: '影片',
        music: '音樂',
        podcast: '播客',
        character: '角色',
        
        // 操作選單
        deleteWork: '刪除作品',
        copyLink: '複製連結',
        
        // 詳情彈窗
        detailDescription: '這是一個由 WeryAI 生成的精彩作品。',
        podcastSpeakers: '說話人',
        podcastScript: '播客腳本',
        generationParams: '生成參數',
        prompt: '提示詞',
        ratio: '比例',
        model: '模型',
        
        // 訊息提示
        copySuccess: '複製成功',
        copyFailed: '複製失敗',
        downloadFailed: '下載失敗',
        
        // 無限滾動提示
        loadingMore: '載入中...',
        noMoreData: '已經到底了',
        loadMoreFailed: '載入失敗，點擊重試',
        
        // 詳情標題
        aiCreation: 'AI創作',
        
        // 分享文案
        shareImageText: '用 AI 生成你想像中的任何畫面 ｜Wery AI',
        shareVideoText: '讓想法直接變成高品質影片 ｜Wery AI',
        shareMusicText: '用 AI 生成音樂與聲音內容 ｜Wery AI',
    },
    pl: {
        // Page title
        pageTitle: 'Moje prace',
        filterTitle: 'Filtruj prace',

        // Filters
        all: 'Wszystko',
        videos: 'Wideo',
        images: 'Obrazy',
        filterByTime: 'Filtruj według czasu',
        filterByType: 'Filtruj według typu',

        // Status messages
        loading: 'Ładowanie...',

        // Content related
        changeBackgroundToYellow: 'Zmień tło na żółte',

        // Preview modal
        download: 'Pobierz',
        downloading: 'Pobieranie...',

        // Empty state
        noContentTitle: 'Brak utworzonych treści',
        noContentDescription:
            'Rozpocznij swoją kreatywną podróż, tworząc pierwszą treść wygenerowaną przez AI',
        createVideoNow: 'Utwórz wideo teraz',
        emptyTitle: 'Ups! Wygląda na to, że jeszcze nic nie utworzyłeś.',
        createNow: 'Utwórz teraz',
        emptyStateIcon: 'Ikona pustego stanu',

        // Action buttons
        preview: 'Podgląd',
        expand: 'Rozwiń',
        edit: 'Edytuj',
        downloadContent: 'Pobierz treść',

        // Content types
        imageCreation: 'Tworzenie obrazów',
        videoCreation: 'Tworzenie wideo',

        // Pagination
        pagination: {
            total: 'Łącznie {total} elementów',
            items: 'elementów/stronę',
        },
        start_vip: 'Zostań VIP',
        vip_benefits: 'Odblokuj nielimitowane tworzenie i jakość 4K Ultra HD',
        right_now: 'Ulepsz teraz',
        next_billing_date: 'Data wygaśnięcia: {time}',
        my_creations: 'Moje prace',
        total_creations: 'Łącznie {total_number}',
        credits: 'Saldo kredytów',
        recharge: 'Doładuj',
        lock_tips: 'Odblokuj nielimitowane tworzenie i ekskluzywne korzyści',
        
        // Nowa zawartość
        type: 'Typ',
        query: 'Zapytanie',
        startDate: 'Data rozpoczęcia',
        endDate: 'Data zakończenia',
        
        // Etykiety typu treści
        image: 'Obraz',
        video: 'Wideo',
        music: 'Muzyka',
        podcast: 'Podcast',
        character: 'Postać',
        
        // Menu akcji
        deleteWork: 'Usuń pracę',
        copyLink: 'Kopiuj link',
        
        // Modal szczegółów
        detailDescription: 'To niesamowita kreacja wygenerowana przez WeryAI.',
        podcastSpeakers: 'Mówcy',
        podcastScript: 'Scenariusz podcastu',
        generationParams: 'Parametry generowania',
        prompt: 'Podpowiedź',
        ratio: 'Proporcje',
        model: 'Model',
        
        // Wskazówki wiadomości
        copySuccess: 'Kopiowanie zakończone sukcesem',
        copyFailed: 'Kopiowanie nie powiodło się',
        downloadFailed: 'Pobieranie nie powiodło się',
        
        // Wskazówki nieskończonego przewijania
        loadingMore: 'Ładowanie...',
        noMoreData: 'Brak więcej danych',
        loadMoreFailed: 'Ładowanie nie powiodło się, kliknij aby spróbować ponownie',
        
        // Tytuł szczegółów
        aiCreation: 'Kreacja AI',
        
        // Tekst do udostępnienia
        shareImageText: 'Generuj dowolną scenę, którą wyobrażasz sobie za pomocą AI | Wery AI',
        shareVideoText: 'Przekształć pomysły w wysokiej jakości wideo | Wery AI',
        shareMusicText: 'Generuj muzykę i treści dźwiękowe za pomocą AI | Wery AI',
    },
    th: {
        // Page title
        pageTitle: 'ผลงานของฉัน',
        filterTitle: 'กรองผลงาน',

        // Filters
        all: 'ทั้งหมด',
        videos: 'วิดีโอ',
        images: 'รูปภาพ',
        filterByTime: 'กรองตามเวลา',
        filterByType: 'กรองตามประเภท',

        // Status messages
        loading: 'กำลังโหลด...',

        // Content related
        changeBackgroundToYellow: 'เปลี่ยนพื้นหลังเป็นสีเหลือง',

        // Preview modal
        download: 'ดาวน์โหลด',
        downloading: 'กำลังดาวน์โหลด...',

        // Empty state
        noContentTitle: 'ยังไม่มีเนื้อหาที่สร้าง',
        noContentDescription:
            'เริ่มต้นเส้นทางสร้างสรรค์ของคุณด้วยการสร้างคอนเทนต์ AI ชิ้นแรก',
        createVideoNow: 'สร้างวิดีโอเลย',
        emptyTitle: 'อุ๊ย! ดูเหมือนว่าคุณยังไม่ได้สร้างอะไรเลย',
        createNow: 'สร้างเลย',
        emptyStateIcon: 'ไอคอนสถานะว่าง',

        // Action buttons
        preview: 'ดูตัวอย่าง',
        expand: 'ขยาย',
        edit: 'แก้ไข',
        downloadContent: 'ดาวน์โหลดเนื้อหา',

        // Content types
        imageCreation: 'การสร้างภาพ',
        videoCreation: 'การสร้างวิดีโอ',

        // Pagination
        pagination: {
            total: 'ทั้งหมด {total} รายการ',
            items: 'รายการ/หน้า',
        },
        start_vip: 'สมัคร VIP',
        vip_benefits: 'ปลดล็อกการสร้างไม่จำกัดและคุณภาพ 4K Ultra HD',
        right_now: 'อัปเกรดตอนนี้',
        next_billing_date: 'วันหมดอายุ: {time}',
        my_creations: 'ผลงานของฉัน',
        total_creations: 'รวม {total_number} รายการ',
        credits: 'ยอดเครดิต',
        recharge: 'เติมเงิน',
        lock_tips: 'ปลดล็อกโควตาการสร้างไม่จำกัดและสิทธิพิเศษเฉพาะ',
        
        // เนื้อหาใหม่
        type: 'ประเภท',
        query: 'ค้นหา',
        startDate: 'วันที่เริ่มต้น',
        endDate: 'วันที่สิ้นสุด',
        
        // ป้ายกำกับประเภทเนื้อหา
        image: 'รูปภาพ',
        video: 'วิดีโอ',
        music: 'เพลง',
        podcast: 'พอดแคสต์',
        character: 'ตัวละคร',
        
        // เมนูการดำเนินการ
        deleteWork: 'ลบผลงาน',
        copyLink: 'คัดลอกลิงก์',
        
        // หน้าต่างรายละเอียด
        detailDescription: 'นี่คือผลงานที่น่าทึ่งที่สร้างโดย WeryAI',
        podcastSpeakers: 'ผู้พูด',
        podcastScript: 'สคริปต์พอดแคสต์',
        generationParams: 'พารามิเตอร์การสร้าง',
        prompt: 'พรอมต์',
        ratio: 'อัตราส่วน',
        model: 'โมเดล',
        
        // คำแนะนำข้อความ
        copySuccess: 'คัดลอกสำเร็จ',
        copyFailed: 'คัดลอกล้มเหลว',
        downloadFailed: 'ดาวน์โหลดล้มเหลว',
        
        // คำแนะนำการเลื่อนไม่สิ้นสุด
        loadingMore: 'กำลังโหลด...',
        noMoreData: 'ไม่มีข้อมูลเพิ่มเติม',
        loadMoreFailed: 'การโหลดล้มเหลว คลิกเพื่อลองอีกครั้ง',
        
        // หัวข้อรายละเอียด
        aiCreation: 'การสร้างสรรค์ AI',
        
        // ข้อความแชร์
        shareImageText: 'สร้างทุกฉากที่คุณจินตนาการด้วย AI | Wery AI',
        shareVideoText: 'เปลี่ยนไอเดียให้กลายเป็นวิดีโอคุณภาพสูง | Wery AI',
        shareMusicText: 'สร้างเพลงและเนื้อหาเสียงด้วย AI | Wery AI',
    },
    da: {
        // Page title
        pageTitle: 'Mine kreationer',
        filterTitle: 'Filtrer kreationer',

        // Filters
        all: 'Alle',
        videos: 'Videoer',
        images: 'Billeder',
        filterByTime: 'Filtrer efter tid',
        filterByType: 'Filtrer efter type',

        // Status messages
        loading: 'Indlæser...',

        // Content related
        changeBackgroundToYellow: 'Skift baggrunden til gul',

        // Preview modal
        download: 'Download',
        downloading: 'Downloader...',

        // Empty state
        noContentTitle: 'Intet indhold oprettet endnu',
        noContentDescription:
            'Start din kreative rejse ved at lave dit første AI-genererede indhold',
        createVideoNow: 'Opret video nu',
        emptyTitle: 'Ups! Det ser ud til, at du ikke har oprettet noget endnu.',
        createNow: 'Opret nu',
        emptyStateIcon: 'Ikon for tom tilstand',

        // Action buttons
        preview: 'Forhåndsvisning',
        expand: 'Udvid',
        edit: 'Rediger',
        downloadContent: 'Download indhold',

        // Content types
        imageCreation: 'Billedoprettelse',
        videoCreation: 'Videooprettelse',

        // Pagination
        pagination: {
            total: 'I alt {total} elementer',
            items: 'elementer/side',
        },
        start_vip: 'Bliv VIP',
        vip_benefits: 'Lås op for ubegrænsede kreationer og 4K Ultra HD-kvalitet',
        right_now: 'Opgrader nu',
        next_billing_date: 'Udløbsdato: {time}',
        my_creations: 'Mine værker',
        total_creations: 'I alt {total_number}',
        credits: 'Kreditsaldo',
        recharge: 'Tank op',
        lock_tips: 'Lås op for ubegrænset oprettelse og eksklusive fordele',
        
        // Nyt indhold
        type: 'Type',
        query: 'Forespørgsel',
        startDate: 'Startdato',
        endDate: 'Slutdato',
        
        // Indholdstype mærkater
        image: 'Billede',
        video: 'Video',
        music: 'Musik',
        podcast: 'Podcast',
        character: 'Karakter',
        
        // Handlingsmenu
        deleteWork: 'Slet værk',
        copyLink: 'Kopier link',
        
        // Detalje modal
        detailDescription: 'Dette er en fantastisk kreation genereret af WeryAI.',
        podcastSpeakers: 'Talere',
        podcastScript: 'Podcast-manuskript',
        generationParams: 'Genereringsparametre',
        prompt: 'Prompt',
        ratio: 'Forhold',
        model: 'Model',
        
        // Besked tips
        copySuccess: 'Kopiering lykkedes',
        copyFailed: 'Kopiering mislykkedes',
        downloadFailed: 'Download mislykkedes',
        
        // Uendelig scroll tips
        loadingMore: 'Indlæser...',
        noMoreData: 'Ingen flere data',
        loadMoreFailed: 'Indlæsning mislykkedes, klik for at prøve igen',
        
        // Detaljetitel
        aiCreation: 'AI-kreation',
        
        // Del tekst
        shareImageText: 'Generer enhver scene du forestiller dig med AI | Wery AI',
        shareVideoText: 'Forvandl ideer til videoer i høj kvalitet | Wery AI',
        shareMusicText: 'Generer musik og lydindhold med AI | Wery AI',
    },
    no: {
        // Page title
        pageTitle: 'Mine kreasjoner',
        filterTitle: 'Filtrer kreasjoner',

        // Filters
        all: 'Alle',
        videos: 'Videoer',
        images: 'Bilder',
        filterByTime: 'Filtrer etter tid',
        filterByType: 'Filtrer etter type',

        // Status messages
        loading: 'Laster...',

        // Content related
        changeBackgroundToYellow: 'Endre bakgrunnen til gul',

        // Preview modal
        download: 'Last ned',
        downloading: 'Laster ned...',

        // Empty state
        noContentTitle: 'Ingen innhold opprettet ennå',
        noContentDescription:
            'Start den kreative reisen din ved å lage ditt første AI-genererte innhold',
        createVideoNow: 'Opprett video nå',
        emptyTitle: 'Oops! Det ser ut som du ikke har opprettet noe ennå.',
        createNow: 'Opprett nå',
        emptyStateIcon: 'Ikon for tom tilstand',

        // Action buttons
        preview: 'Forhåndsvisning',
        expand: 'Utvid',
        edit: 'Rediger',
        downloadContent: 'Last ned innhold',

        // Content types
        imageCreation: 'Bildeopprettelse',
        videoCreation: 'Videoopprettelse',

        // Pagination
        pagination: {
            total: 'Totalt {total} elementer',
            items: 'elementer/side',
        },
        start_vip: 'Bli VIP',
        vip_benefits: 'Lås opp ubegrenset skapelse og 4K Ultra HD-kvalitet',
        right_now: 'Oppgrader nå',
        next_billing_date: 'Utløpsdato: {time}',
        my_creations: 'Mine verk',
        total_creations: 'Totalt {total_number}',
        credits: 'Kredittsaldo',
        recharge: 'Fyll på',
        lock_tips: 'Lås opp ubegrenset skapingskvote og eksklusive fordeler',
        
        // Nytt innhold
        type: 'Type',
        query: 'Spørring',
        startDate: 'Startdato',
        endDate: 'Sluttdato',
        
        // Innholdstype merkelapper
        image: 'Bilde',
        video: 'Video',
        music: 'Musikk',
        podcast: 'Podkast',
        character: 'Karakter',
        
        // Handlingsmeny
        deleteWork: 'Slett verk',
        copyLink: 'Kopier lenke',
        
        // Detaljmodal
        detailDescription: 'Dette er en fantastisk skapelse generert av WeryAI.',
        podcastSpeakers: 'Talere',
        podcastScript: 'Podkastmanus',
        generationParams: 'Genereringsparametere',
        prompt: 'Prompt',
        ratio: 'Forhold',
        model: 'Modell',
        
        // Meldingstips
        copySuccess: 'Kopiering vellykket',
        copyFailed: 'Kopiering mislyktes',
        downloadFailed: 'Nedlasting mislyktes',
        
        // Uendelig rullingstips
        loadingMore: 'Laster...',
        noMoreData: 'Ingen flere data',
        loadMoreFailed: 'Lasting mislyktes, klikk for å prøve igjen',
        
        // Detaljetittel
        aiCreation: 'AI-skapelse',
        
        // Del tekst
        shareImageText: 'Generer hvilken som helst scene du forestiller deg med AI | Wery AI',
        shareVideoText: 'Forvandl ideer til videoer av høy kvalitet | Wery AI',
        shareMusicText: 'Generer musikk og lydinnhold med AI | Wery AI',
    },
    nl: {
        // Page title
        pageTitle: 'Mijn creaties',
        filterTitle: 'Creations filteren',

        // Filters
        all: 'Alles',
        videos: "Video's",
        images: 'Afbeeldingen',
        filterByTime: 'Filter op tijd',
        filterByType: 'Filter op type',

        // Status messages
        loading: 'Bezig met laden...',

        // Content related
        changeBackgroundToYellow: 'Verander achtergrond naar geel',

        // Preview modal
        download: 'Download',
        downloading: 'Downloaden...',

        // Empty state
        noContentTitle: 'Nog geen content gemaakt',
        noContentDescription:
            'Start je creatieve reis door je eerste AI-gegenereerde content te maken',
        createVideoNow: 'Maak nu een video',
        emptyTitle: 'Oeps! Het lijkt erop dat je nog niets hebt gemaakt.',
        createNow: 'Maak nu',
        emptyStateIcon: 'Leegstatus-icoon',

        // Action buttons
        preview: 'Voorbeeld',
        expand: 'Uitvouwen',
        edit: 'Bewerken',
        downloadContent: 'Content downloaden',

        // Content types
        imageCreation: 'Afbeeldingscreatie',
        videoCreation: 'Videocreatie',

        // Pagination
        pagination: {
            total: 'Totaal {total} items',
            items: 'items/pagina',
        },
        start_vip: 'Word VIP',
        vip_benefits: 'Ontgrendel onbeperkte creaties en 4K Ultra HD-kwaliteit',
        right_now: 'Upgrade nu',
        next_billing_date: 'Vervaldatum: {time}',
        my_creations: 'Mijn creaties',
        total_creations: 'Totaal {total_number}',
        credits: 'Creditsaldo',
        recharge: 'Opwaarderen',
        lock_tips:
            'Ontgrendel onbeperkte creatielimiet en exclusieve voordelen',
        
        // Nieuwe inhoud
        type: 'Type',
        query: 'Zoekopdracht',
        startDate: 'Startdatum',
        endDate: 'Einddatum',
        
        // Inhoudstype labels
        image: 'Afbeelding',
        video: 'Video',
        music: 'Muziek',
        podcast: 'Podcast',
        character: 'Karakter',
        
        // Actiemenu
        deleteWork: 'Verwijder werk',
        copyLink: 'Kopieer link',
        
        // Detail modal
        detailDescription: 'Dit is een geweldige creatie gegenereerd door WeryAI.',
        podcastSpeakers: 'Sprekers',
        podcastScript: 'Podcastscript',
        generationParams: 'Generatieparameters',
        prompt: 'Prompt',
        ratio: 'Verhouding',
        model: 'Model',
        
        // Berichttips
        copySuccess: 'Kopiëren gelukt',
        copyFailed: 'Kopiëren mislukt',
        downloadFailed: 'Download mislukt',
        
        // Oneindige scrolltips
        loadingMore: 'Bezig met laden...',
        noMoreData: 'Geen gegevens meer',
        loadMoreFailed: 'Laden mislukt, klik om opnieuw te proberen',
        
        // Detailtitel
        aiCreation: 'AI-creatie',
        
        // Deel tekst
        shareImageText: 'Genereer elke scène die je je voorstelt met AI | Wery AI',
        shareVideoText: 'Verander ideeën in video\'s van hoge kwaliteit | Wery AI',
        shareMusicText: 'Genereer muziek en geluidsinhoud met AI | Wery AI',
    },
    id: {
        // Page title
        pageTitle: 'Kreasi Saya',
        filterTitle: 'Filter kreasi',

        // Filters
        all: 'Semua',
        videos: 'Video',
        images: 'Gambar',
        filterByTime: 'Filter berdasarkan waktu',
        filterByType: 'Filter berdasarkan jenis',

        // Status messages
        loading: 'Memuat...',

        // Content related
        changeBackgroundToYellow: 'Ubah latar belakang menjadi kuning',

        // Preview modal
        download: 'Unduh',
        downloading: 'Mengunduh...',

        // Empty state
        noContentTitle: 'Belum ada konten yang dibuat',
        noContentDescription:
            'Mulai perjalanan kreatifmu dengan membuat konten AI pertamamu',
        createVideoNow: 'Buat Video Sekarang',
        emptyTitle: 'Ups! Sepertinya kamu belum membuat apa pun.',
        createNow: 'Buat Sekarang',
        emptyStateIcon: 'Ikon status kosong',

        // Action buttons
        preview: 'Pratinjau',
        expand: 'Perluas',
        edit: 'Edit',
        downloadContent: 'Unduh Konten',

        // Content types
        imageCreation: 'Pembuatan gambar',
        videoCreation: 'Pembuatan video',

        // Pagination
        pagination: {
            total: 'Total {total} item',
            items: 'item/halaman',
        },
        start_vip: 'Jadi VIP',
        vip_benefits: 'Buka kreasi tanpa batas dan kualitas 4K Ultra HD',
        right_now: 'Tingkatkan sekarang',
        next_billing_date: 'Tanggal kedaluwarsa: {time}',
        my_creations: 'Karya saya',
        total_creations: 'Total {total_number}',
        credits: 'Saldo kredit',
        recharge: 'Isi ulang',
        lock_tips: 'Buka kuota kreasi tanpa batas dan manfaat eksklusif',
        
        // Konten baru
        type: 'Jenis',
        query: 'Kueri',
        startDate: 'Tanggal mulai',
        endDate: 'Tanggal akhir',
        
        // Label jenis konten
        image: 'Gambar',
        video: 'Video',
        music: 'Musik',
        podcast: 'Podcast',
        character: 'Karakter',
        
        // Menu tindakan
        deleteWork: 'Hapus karya',
        copyLink: 'Salin tautan',
        
        // Modal detail
        detailDescription: 'Ini adalah kreasi luar biasa yang dihasilkan oleh WeryAI.',
        podcastSpeakers: 'Pembicara',
        podcastScript: 'Skrip podcast',
        generationParams: 'Parameter generasi',
        prompt: 'Prompt',
        ratio: 'Rasio',
        model: 'Model',
        
        // Tips pesan
        copySuccess: 'Salin berhasil',
        copyFailed: 'Salin gagal',
        downloadFailed: 'Unduh gagal',
        
        // Tips scroll tak terbatas
        loadingMore: 'Memuat...',
        noMoreData: 'Tidak ada data lagi',
        loadMoreFailed: 'Muat gagal, klik untuk mencoba lagi',
        
        // Judul detail
        aiCreation: 'Kreasi AI',
        
        // Teks berbagi
        shareImageText: 'Hasilkan adegan apa pun yang Anda bayangkan dengan AI | Wery AI',
        shareVideoText: 'Ubah ide menjadi video berkualitas tinggi | Wery AI',
        shareMusicText: 'Hasilkan musik dan konten suara dengan AI | Wery AI',
    },
    tr: {
        // Page title
        pageTitle: 'Eserlerim',
        filterTitle: 'Oluşturulanları filtrele',

        // Filters
        all: 'Tümü',
        videos: 'Videolar',
        images: 'Görseller',
        filterByTime: 'Zamana göre filtrele',
        filterByType: 'Türe göre filtrele',

        // Status messages
        loading: 'Yükleniyor...',

        // Content related
        changeBackgroundToYellow: 'Arka planı sarıya değiştir',

        // Preview modal
        download: 'İndir',
        downloading: 'İndiriliyor...',

        // Empty state
        noContentTitle: 'Henüz içerik oluşturulmadı',
        noContentDescription:
            'İlk yapay zeka içeriğini oluşturarak yaratıcı yolculuğuna başla',
        createVideoNow: 'Şimdi Video Oluştur',
        emptyTitle: 'Hoppala! Görünüşe göre henüz hiçbir şey oluşturmadın.',
        createNow: 'Şimdi Oluştur',
        emptyStateIcon: 'Boş durum simgesi',

        // Action buttons
        preview: 'Önizleme',
        expand: 'Genişlet',
        edit: 'Düzenle',
        downloadContent: 'İçeriği indir',

        // Content types
        imageCreation: 'Görsel oluşturma',
        videoCreation: 'Video oluşturma',

        // Pagination
        pagination: {
            total: 'Toplam {total} öğe',
            items: 'öğe/sayfa',
        },
        start_vip: 'VIP ol',
        vip_benefits: 'Sınırsız oluşturma ve 4K Ultra HD kaliteyi aç',
        right_now: 'Şimdi yükselt',
        next_billing_date: 'Bitiş tarihi: {time}',
        my_creations: 'Eserlerim',
        total_creations: 'Toplam {total_number}',
        credits: 'Kredi bakiyesi',
        recharge: 'Yükle',
        lock_tips: 'Sınırsız oluşturma kotası ve özel ayrıcalıkları aç',
        
        // Yeni içerik
        type: 'Tür',
        query: 'Sorgu',
        startDate: 'Başlangıç tarihi',
        endDate: 'Bitiş tarihi',
        
        // İçerik türü etiketleri
        image: 'Görsel',
        video: 'Video',
        music: 'Müzik',
        podcast: 'Podcast',
        character: 'Karakter',
        
        // Eylem menüsü
        deleteWork: 'Eseri sil',
        copyLink: 'Bağlantıyı kopyala',
        
        // Detay modalı
        detailDescription: 'Bu, WeryAI tarafından oluşturulan harika bir eser.',
        podcastSpeakers: 'Konusmacilar',
        podcastScript: 'Podcast senaryosu',
        generationParams: 'Oluşturma parametreleri',
        prompt: 'İstem',
        ratio: 'Oran',
        model: 'Model',
        
        // Mesaj ipuçları
        copySuccess: 'Kopyalama başarılı',
        copyFailed: 'Kopyalama başarısız',
        downloadFailed: 'İndirme başarısız',
        
        // Sonsuz kaydırma ipuçları
        loadingMore: 'Yükleniyor...',
        noMoreData: 'Daha fazla veri yok',
        loadMoreFailed: 'Yükleme başarısız, yeniden denemek için tıklayın',
        
        // Detay başlığı
        aiCreation: 'Yapay Zeka Yaratıcılığı',
        
        // Paylaşım metni
        shareImageText: 'Hayal ettiğiniz her sahneyi AI ile oluşturun | Wery AI',
        shareVideoText: 'Fikirleri yüksek kaliteli videolara dönüştürün | Wery AI',
        shareMusicText: 'AI ile müzik ve ses içeriği oluşturun | Wery AI',
    },
}
